module.exports = __webpack_public_path__ + "static/media/xdn.3311a255.svg";